export default "__VITE_ASSET__xxiffY0c__"